import React, { useEffect, useRef } from 'react';
import { Button as BButton } from 'react-bootstrap';
import './button.css'
const Button = ({ classList, variant, icon, text, addonClass, children = null, onClick, type, ...restProps }) => {
    const btnRef = useRef(null);

    // Enter/Return within this submit button's form (or its modal, when there
    // is no <form>) acts as a click on it, so users can proceed straight from
    // the keyboard without reaching for the mouse. Scoped to that container —
    // never a page-wide listener — so buttons elsewhere on the page and green
    // toolbar buttons that live outside any form/modal are untouched.
    useEffect(() => {
        if (type !== "submit") return;

        const btn = btnRef.current;
        if (!btn) return;

        const form = btn.closest("form");
        const scope =
            form || btn.closest(".modal, [role='dialog']");
        // No form and no modal to anchor to — don't hijack Enter globally.
        if (!scope) return;

        const handleKeyDown = (event) => {
            if (event.key !== "Enter" || event.defaultPrevented) return;

            const el = event.target;
            // Let these keep their own Enter behaviour (newlines, activation).
            if (
                !el ||
                el.tagName === "TEXTAREA" ||
                el.tagName === "BUTTON" ||
                el.tagName === "A" ||
                el.tagName === "SELECT" ||
                el.isContentEditable
            ) {
                return;
            }
            if (!scope.contains(el)) return;
            if (btn.disabled) return;

            if (typeof onClick === "function") {
                // Button owns its submit logic — don't also fire native submit.
                event.preventDefault();
                // Hand the click handler a minimal event-like object so
                // handlers that call e.preventDefault()/e.stopPropagation()
                // (or read e.currentTarget) don't blow up on a keyboard trigger.
                onClick({
                    preventDefault: () => {},
                    stopPropagation: () => {},
                    currentTarget: btn,
                    target: btn,
                    nativeEvent: event,
                });
            } else if (form) {
                // Native / onSubmit form flow (e.g. Login).
                event.preventDefault();
                if (typeof form.requestSubmit === "function") {
                    form.requestSubmit(btn);
                } else {
                    btn.click();
                }
            }
        };

        scope.addEventListener("keydown", handleKeyDown);
        return () => {
            scope.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClick, type]);

    // Support both variant and classList props for backward compatibility
    const buttonClassList = variant ? variant : classList;

    if (children) return { children };
    return (
        <div className={`${buttonClassList?.split(' ').map(item => `custom-button-${item}`).join(' ')} ${addonClass != undefined ? addonClass : ''}`}>
            <BButton ref={btnRef} onClick={onClick} type={type || "button"} {...restProps}>
              {icon ? icon : ""}  {text}
            </BButton>
        </div>
    )
}
export default Button;